<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
      All Curve History
    </div>
    <div class="content">
      <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          pulling-text="Pull down to refresh"
          loading-text="Loading..."
          success-text="Refresh success"
          loosing-text="Release to refresh"
      >
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="No more data"
            loading-text="Loading more..."
            :error.sync="error"
            error-text="Load fail! Click reload"
            @load="onLoad"
        >
          <div
              class="history-item"
              v-for="(item, index) in historyList"
              :key="index"
          >

            <CurveItem
                v-if="isBrandUser"
                :key="item.id"
                show-favorite
                :power="item.power"
                :device-type="item.deviceType"
                :max-power="item.maxPower"
                :tag-id="item.tagId"
                :create-time="item.createTime"
                :is-favorite="item.isFavorite"
                @onApply="onApply(index,item)"
                @onFavorite="onFavorite(index,item)"/>
            <ConsumerCurveItem
                v-else
                :key="item.id"
                show-favorite
                :power="item.power"
                :flavor-name="item.flavorName"
                :flavor-picture="item.flavorPicture"
                :device-type="item.deviceType"
                :max-power="item.maxPower"
                :tag-id="item.tagId"
                :create-time="item.createTime"
                :is-favorite="item.isFavorite"
                @onApply="onApply(index,item)"
                @onFavorite="onFavorite(index,item)"/>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import log from "@/util/log";
import { WriterSetting } from "@/bluetooth/BluetoothData";
import { calcMaxPower, calcPower, calcVoltageFloorInt } from "../util/utils";
import HistoryCurve from "@/views/HistoryCurve.vue";
import { mapState } from "vuex";
import CurveItem from "@/components/history/CurveItem.vue";
import user from "@/api/user";
import userMixin from "@/mixins/userMixin";
import SystemCurve from "@/components/home/SystemCurve.vue";
import SystemCurveItem from "@/components/home/SystemCurveItem.vue";
import ConsumerCurveItem from "@/components/history/ConsumerCurveItem.vue";

export default {
  name: "History",
  mixins: [userMixin],
  components: { ConsumerCurveItem, SystemCurveItem, SystemCurve, CurveItem, HistoryCurve },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      historyList: [],
      pageNum: 1,
      pageSize: 10
    };
  },
  created() {
  },
  async mounted() {
  },
  computed: {
    ...mapState("theme", ["curveColor", "curveLineColor", "syncButtonColor"])
  },
  methods: {
    onClickHeaderReturn() {
      this.$router.go(-1);
    },
    onApply(index, item) {
      const writerSetting = new WriterSetting();
      Object.assign(writerSetting, item);
      const name = this.$route.query.modelType == 1 ? "Enterprise" : "BtHome";
      this.$router.replace({
        name,
        params: {
          writerSetting
        }
      });
    },
    async onFavorite(index, item) {
      try {
        const isFavorite = item.isFavorite ? 0 : 1;
        const resp = await user.favoriteCurve({
          id: item.id,
          isFavorite: isFavorite
        }, true);
        if (resp.code !== 200) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return
        }
        this.$set(this.historyList, index, { ...this.historyList[index], isFavorite });
        this.historyList[index].isFavorite = isFavorite;
        this.$toast({
          type: "success",
          message: resp.message
        });
      } catch (e) {
        this.$toast({
          type: "fail",
          message: e
        });
      }

    },
    async onRefresh() {
      this.refreshing = true;
      this.onLoad();
    },
    async onLoad() {
      //如果是刷新
      if (this.refreshing) {
        this.pageNum = 1;
        this.historyList = [];
      }
      try {
        let response = await this.$api.User.selectUploadHistory({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          modelType: this.$route.query.modelType || 0
        });
        const history = response.data;
        const total = response.total;
        // log(history);
        this.historyList = this.historyList.concat(
            history.map(item => {
              const setting = new WriterSetting();
              setting.id = item.id;
              setting.isFavorite = item.isFavorite;
              setting.diyVoltage = item.heatingVoltage
                  .split(",")
                  .map(item => parseInt(item));
              setting.isSupportNfc = item.nfcSettings === 1;
              setting.isSupportPreheat = item.preheatSetting === 1;
              setting.modeName = item.modeName;
              setting.preheatTime = item.preheatTime;
              setting.preheatVoltage = item.preheatVoltage;
              setting.createTime = item.createTime;
              setting.resistance = item.resistance;
              setting.tagId = item.tagId;
              setting.flavorName= item.flavorName;
              setting.flavorPicture = item.flavorPicture
              setting.deviceType = item.deviceType ? item.deviceType : "Unknown Device";

              const diyVoltage = item.heatingVoltage.split(",").map(voltage => parseInt(voltage));
              const limitMaxVoltage = calcVoltageFloorInt(item.maxPower, item.resistance);
              const maxPower = calcMaxPower(limitMaxVoltage, item.resistance);
              setting.maxPower = maxPower;
              setting.diyVoltage = diyVoltage;
              setting.power = diyVoltage.map(voltage => parseFloat(calcPower(voltage, item.resistance, maxPower).toFixed(2)));

              setting.originDiyVoltage = diyVoltage;
              setting.originPreheatVoltage = item.preheatVoltage;
              setting.originPreheatTime = item.preheatTime;
              setting.originIsSupportNfc = item.isSupportNfc;
              setting.originIsSupportPreheat = item.isSupportPreheat;
              setting.modelType = item.modelType;
              return setting;
            })
        );

        //刷新结束
        if (this.refreshing) {
          this.refreshing = false;
        } else {
          this.loading = false;
        }
        if (this.historyList.length >= total) {
          this.finished = true;
        }
        this.pageNum += 1;
      } catch (e) {
        log(e);
        this.loading = false;
        this.error = true;
      }
    },
    calcHistoryPower(voltage, r, maxPower) {
      return calcPower(voltage, r, maxPower);
    }
  }
};
//圆点
</script>
<style lang="less" scoped>
.container {
  height: 100%;
  background: #FFFFFF;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .header {
    width: 100%;
    height: 60px;
    min-height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #545554;

    .header-return {
      position: absolute;
      left: 10px;
    }
  }

  .content {
    height: 100%;
    overflow-y: auto;
    background: #f6f6f6;
    // .history-item:last-child {
    //   margin-bottom: 16px;
    // }

    .history-item {
      margin-left: 16px;
      margin-right: 16px;
      background: #ffffff;
      border-radius: 12px;
    }
  }
}

.van-list {
  text-align: center;

  & > * {
    margin-top: 12px;
  }

}
</style>
